import Paper from "@mui/material/Paper";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import { Link, useMatch } from "react-router-dom";
import { t } from "i18next";
import Box from "@mui/material/Box";
import CalendarIcon from "../Icons/CalendarIcon";
import ChatIcon from "../Icons/ChatIcon";
import PhoneIcon from "../Icons/PhoneIcon";
import { PHONE_NUMBER } from "../../utils/constants";

export default function Footer() {
  return (
    <Paper
      sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}
      elevation={3}
    >
      <BottomNavigation showLabels>
        <BottomNavigationAction
          sx={
            useMatch("/callback")
              ? {
                  backgroundColor: "primary.main",
                  color: "primary.contrastText",
                }
              : null
          }
          value="callback"
          to="/callback"
          component={Link}
          label={<Box>{t("footer.bookCall")}</Box>}
          icon={<CalendarIcon />}
        />
        <BottomNavigationAction
          sx={
            useMatch("/chat")
              ? {
                  backgroundColor: "primary.main",
                  color: "primary.contrastText",
                }
              : null
          }
          value="chat"
          to="/chat"
          component={Link}
          label={t("footer.chatNow")}
          icon={<ChatIcon />}
        />
        <BottomNavigationAction
          href={"tel:" + PHONE_NUMBER}
          label={t("footer.callNow", { phoneNumber: PHONE_NUMBER })}
          icon={<PhoneIcon />}
        />
      </BottomNavigation>
    </Paper>
  );
}
